import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { prototyperPermissionsBackend } from './prototyper-permissions.backend';
import { prototyperPermissionsReducer } from './prototyper-permissions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'prototyperPermissions',
      prototyperPermissionsReducer,
    ),
    BackendModule.forFeature(
      'prototyperPermissions',
      prototyperPermissionsBackend,
    ),
  ],
})
export class DatastorePrototyperPermissionsModule {}
